"use client";

import { useSession } from "next-auth/react";
import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";

export default function ContactForm() {
  const { data: session } = useSession();
  const { toast } = useToast();

  const [name, setName] = useState(session?.user?.name || "");
  const [email, setEmail] = useState(session?.user?.email || "");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, message }),
      });

      if (res.ok) {
        toast({ title: "Success", description: "Message sent successfully" });
        setMessage("");
      }
    } catch (error) {
      console.error("Failed to send message:", error);
      toast({
        title: "Error",
        description: "Failed to send message, please try again.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col justify-center p-8 bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700">
      <div className="w-full mx-auto">
        <h1 className="mb-2 text-2xl font-normal leading-none tracking-tight text-gray-900 dark:text-white">
          {`Send us a message`}
        </h1>
        <p className="text-sm font-light text-gray-500 dark:text-gray-400">
          {`Questions about Execution Excellence, Prep5, or how Salesably can help your team? We'd love to hear from you.`}
        </p>
      </div>
      <div className="mt-4">
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            <div className="mt-2">
              <input
                id="name"
                name="name"
                type="text"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
                className="block w-full py-2 pl-3 pr-10 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 border border-gray-100 dark:border-gray-600 rounded-md shadow-xs bg-gray-50 dark:bg-gray-700 focus:border-blue-500 dark:focus:border-blue-400 focus:ring-blue-500 dark:focus:ring-blue-400 sm:text-sm"
              />
            </div>
          </div>

          <div>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email address"
                className="block w-full py-2 pl-3 pr-10 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 border border-gray-100 dark:border-gray-600 rounded-md shadow-xs bg-gray-50 dark:bg-gray-700 focus:border-blue-500 dark:focus:border-blue-400 focus:ring-blue-500 dark:focus:ring-blue-400 sm:text-sm"
              />
            </div>
          </div>

          <div>
            <div className="mt-2">
              <textarea
                id="message"
                name="message"
                required
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Message"
                className="block w-full py-2 pl-3 pr-10 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 border border-gray-100 dark:border-gray-600 rounded-md shadow-xs bg-gray-50 dark:bg-gray-700 focus:border-blue-500 dark:focus:border-blue-400 focus:ring-blue-500 dark:focus:ring-blue-400 sm:text-sm"
                rows={4}
              ></textarea>
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className={`flex w-full justify-center rounded-full bg-blue-600 px-3 py-1.5 text-sm font-light leading-6 text-white shadow-sm ${
                loading ? "bg-blue-400" : "hover:bg-blue-500"
              } focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 dark:focus-visible:outline-blue-400`}
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
